import AffiliateProvider from "./AffiliateProvider";

export default AffiliateProvider;
